import { createMuiTheme } from '@material-ui/core/styles';

import {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from '../utils';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: PRIMARY_COLOR,
    },
    secondary: {
      main: SECONDARY_COLOR,
    },
  },
  overrides: {
    MuiAutocomplete: {
      option: {
        '&[data-focus="true"]': {
          backgroundColor: SECONDARY_COLOR,
          color: 'white',
        },
      },
    },
  },
});

export default theme;
